// extracted by mini-css-extract-plugin
export default {"checkedStatus":"UseInvoiceTableColumns_checkedStatus__VFmoX","link":"UseInvoiceTableColumns_link__Lzdqa","number":"UseInvoiceTableColumns_number__9KC2A"};